/** One POST, one idempotent message identity. Never resubmit after a transport failure. */
export async function streamAssistantMessage(conversation, payload, onDelta, signal) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  if (signal) {
    if (signal.aborted) controller.abort();
    else signal.addEventListener('abort', abort);
  }
  const timer = setTimeout(abort, 45000);
  let reader;
  try {
    const response = await fetch(process.env.REACT_APP_API_URL + 'assistant/conversations/' + encodeURIComponent(conversation) + '/messages', {
      method: 'POST', signal: controller.signal,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token'), Accept: 'application/json, text/event-stream', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const data = await response.json().catch(() => ({ message: 'Yanıt alınamadı.' }));
      throw Object.assign(new Error(data.message || 'İstek reddedildi.'), { response: { status: response.status, data } });
    }
    if (!(response.headers.get('Content-Type') || '').includes('text/event-stream')) return await response.json();
    if (!response.body) throw new Error('Yanıt akışı açılamadı.');
    reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '', event = '', lines = [], size = 0, result = null;
    const consume = line => {
      if (line.startsWith('event:')) event = line.slice(6).trim();
      else if (line.startsWith('data:')) lines.push(line.slice(5).trimStart());
      else if (line === '') {
        if (lines.length) {
          const data = JSON.parse(lines.join('\n'));
          if (event === 'delta' && typeof data.text === 'string') onDelta(data.text);
          if (event === 'done') {
            if (data.conversation?.id !== conversation || !Array.isArray(data.conversation.messages)) throw new Error('Geçersiz konuşma sonucu.');
            result = data.conversation;
          }
          if (event === 'error') throw Object.assign(new Error(data.message), { response: { status: data.status || 500, data } });
        }
        event = ''; lines = []; size = 0;
      }
    };
    while (!result) {
      const chunk = await reader.read();
      buffer += chunk.done ? decoder.decode() : decoder.decode(chunk.value, { stream: true });
      if (buffer.length + size > 8 * 1024 * 1024) throw new Error('Yanıt sınırı aşıldı.');
      let end;
      while ((end = buffer.indexOf('\n')) !== -1 && !result) {
        const line = buffer.slice(0, end).replace(/\r$/, ''); buffer = buffer.slice(end + 1); size += line.length;
        consume(line);
      }
      if (chunk.done) break;
    }
    if (!result) throw new Error('Yanıt akışı kesildi. Sonucu kontrol edin.');
    return result;
  } finally {
    clearTimeout(timer);
    if (signal) signal.removeEventListener('abort', abort);
    if (reader) await reader.cancel().catch(() => {});
  }
}
